export class DataModelUpdateCommandeArticle {
    idCommande: number = 0;
    archiver: boolean = false;
}